import React from "react";
import "../admin/style/style-pc.css";
import "../admin/style/style-mob.css";
import img from "../../resources/logo.webp";
import { useNavigate } from "react-router-dom";
import { host } from "../../config/Config";

export const Settings = () => {
    const [newPhone, setNewPhone] = React.useState("");
    const [successMessage, setSuccessMessage] = React.useState(null);
    const [userEmail, setUserEmail] = React.useState("");
    const navigate = useNavigate();

    const userPhoneNumber = localStorage.getItem("zajednica-phone");

    React.useEffect(() => {
        const loadEmail = () => {
            const email = localStorage.getItem("zajednica-email");
            setUserEmail(email || "");
        };

        loadEmail();

        // Reload email when user comes back to this page
        const handleFocus = () => {
            loadEmail();
        };

        window.addEventListener("focus", handleFocus);

        return () => {
            window.removeEventListener("focus", handleFocus);
        };
    }, []);

    const handlePocetna = () => {
        navigate("/profile");
    };

    const handleChangePhone = async () => {
        if (newPhone.length === 0) return; // Ensure the new phone number isn't empty
        try {
            const response = await fetch(
                `${host}/api/v1/users/change-phone/${encodeURIComponent(
                    newPhone
                )}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem(
                            "zajednica-token"
                        )}`,
                    },
                }
            );

            const data = await response.text();

            if (response.ok && data !== "") {
                setNewPhone("");
                setSuccessMessage(true);
                localStorage.setItem("zajednica-phone", newPhone);
                localStorage.setItem("zajednica-token", data);

                setTimeout(() => {
                    setSuccessMessage(null);
                }, 1500);
                // If API returns true, show success message and update localStorage
            } else {
                // If something goes wrong, show an error message
                setSuccessMessage(false);
                setTimeout(() => {
                    setSuccessMessage(null);
                }, 1600);
            }
        } catch (error) {
            console.error("Error changing phone number:", error);
            setSuccessMessage(false);
        }
    };

    return (
        <div className='barber-zajednica-admin-page'>
            <div className='barber-zajednica-admin-background'></div>

            <h2 style={{ marginTop: "60px", color: "#737373" }}>Moj Email</h2>
            <input
                style={{
                    marginTop: "20px",
                    width: "80%",
                    textAlign: "center",
                    padding: "0",
                    color: "gray",
                }}
                type='email'
                readOnly
                value={userEmail}
                className='barber-zajednica-input-password'
                placeholder='Nije unet email'
            />

            <h2 style={{ marginTop: "60px", color: "#737373" }}>
                Moj br. telefona
            </h2>
            <input
                style={{
                    marginTop: "20px",
                    width: "80%",
                    textAlign: "center",
                    padding: "0",
                    color: "gray",
                }}
                type='number'
                readOnly
                value={userPhoneNumber} // Now using state
                className='barber-zajednica-input-password'
            />

            <h2 style={{ marginTop: "50px", color: "#737373" }}>
                Novi br. telefona
            </h2>
            <input
                style={{
                    marginTop: "20px",
                    width: "80%",
                    textAlign: "center",
                    padding: "0",
                }}
                type='number'
                value={newPhone}
                className='barber-zajednica-input-password'
                onChange={(e) => setNewPhone(e.target.value)}
            />

            {successMessage !== null && (
                <h3
                    style={{
                        marginTop: "30px",
                        marginBottom: "-30px",
                        color: successMessage ? "white" : "#961515",
                    }}
                >
                    {successMessage
                        ? "Operacija uspešna"
                        : "Broj je već zauzet"}
                </h3>
            )}

            <button
                onClick={handleChangePhone}
                className='barber-zajednica-login-button-user'
                style={{ marginTop: "70px" }}
            >
                Promeni broj
            </button>

            <button
                onClick={handlePocetna}
                className='barber-zajednica-login-button-user'
                style={{
                    marginTop: "30px",
                    marginBottom: "0px",
                    zIndex: "1000",
                }}
            >
                Nazad na Profil
            </button>
            <div
                className='barber-zajednica-admin-logo'
                style={{ width: "300px" }}
            >
                <img src={img} />
            </div>
        </div>
    );
};
